import IPathModel from "Models/PathModel";

const RouteBuilder = (route: IPathModel) => {
    return route.path + createParameterString(route.params);
}

const createParameterString = (params?: string[]) => {
    if (!params)
        return ''
    return '/' + params.map(param => ':' + param).join('/')
}

export default RouteBuilder;